import { Route, Routes } from 'react-router-dom'

import { AgentImpersonate } from './pages/agent-impersonate/AgentImpersonate'

import { ProtectedRoute } from '@/components/ProtectedRoute'
import { RootLayout } from '@/layout/RootLayout'
import {
    ChangePassword,
    ConfirmEmail,
    CreateAccount,
    EmailSendSuccess,
    InitialInscription,
    Login,
    NotFound,
    PasswordReset,
    ResendConfirmation
} from '@/pages'

export const router = (
    <Routes>
        <Route
            path="/"
            element={<RootLayout />}
            errorElement={<NotFound />}
        >
            <Route
                index
                element={
                    <ProtectedRoute
                        bypassProtection={true}
                        isLogin={true}
                    >
                        <Login />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/agent-impersonate"
                element={<AgentImpersonate />}
            />
            <Route
                path="/confirm-email"
                element={<ConfirmEmail />}
            />
            <Route
                path="/change-password"
                element={<ChangePassword />}
            />
            <Route
                path="/verify-email"
                element={<EmailSendSuccess />}
            />
            <Route
                path="/resend-confirmation"
                element={<ResendConfirmation />}
            />
            <Route
                path="/login"
                element={<Login />}
                errorElement={<NotFound />}
            />
            <Route
                path="/reset-password"
                element={<PasswordReset />}
                errorElement={<NotFound />}
            />
            <Route
                path="initial-inscription"
                element={
                    <ProtectedRoute>
                        <InitialInscription />
                    </ProtectedRoute>
                }
            />
            <Route
                path="createAccount"
                element={
                    <ProtectedRoute
                        isLogin={true}
                        bypassProtection={true}
                    >
                        <CreateAccount />
                    </ProtectedRoute>
                }
            />
        </Route>
    </Routes>
)
